// src/api/options.ts
import request from '@/utils/request';

const apiKey = import.meta.env.VITE_API_KEY

export interface SmsTemplateDto {
  id: number
  name: string
  content: string
}

export interface SmsSendResponse {
  success: boolean
  code?: string
  message?: string
  lastSentAt?: string
  confirmationToken?: string
}

export const smsApi = {
  
  getSmsTemplates() { // 取得簡訊template
    return request({
      url: '/api/SmsSend/templates',
      method: 'get',
      headers: {
        'X-Api-Key': apiKey,
      },
    });
  },

  sendSms(
    id: number | string,
    phone: string,
    reason: string,
    templateId: number | string,
    confirmationToken?: string,
  ) {
    return request<SmsSendResponse, SmsSendResponse>({
      url: '/api/SmsSend/send',
      method: 'post',
      validateStatus: (status: number) =>
        (status >= 200 && status < 300) || status === 409 || status === 500,
      data: {
        CaseId: id,
        Phone: phone,
        Message: reason,
        TemplateId: templateId,
        ConfirmationToken: confirmationToken,
      },
    })
  },
};
